import Api from "../../api/SMPFetchHelper";
import {SessionDataGetSchema} from "../../api/DBSchema/SessionData";

export const SET_USER_ID = 'SET_USER_ID';
export const SET_USER_ROLE = 'SET_USER_ROLE';

export const SET_CURRENT_PORTAL = 'SET_CURRENT_PORTAL';
export const SET_PORTAL_TIME_ZONE = 'SET_PORTAL_TIME_ZONE';
export const SET_AVAILABLE_PORTALS = 'SET_AVAILABLE_PORTALS'; // Portals available for the user to use
export const SET_AVAILABLE_PLANS = 'SET_AVAILABLE_PLANS'; // Plans available in the portal
export const SET_IS_CYBER_VIEWS_ENABLED = 'SET_IS_CYBER_VIEWS_ENABLED';
export const SET_IS_SME_LOGS_ENABLED = 'SET_IS_SME_LOGS_ENABLED';

export const RESET_USER = 'RESET_USER'; // To use in logout

export function setUserId(userId) {
    return {
        type: SET_USER_ID,
        payload: {
            userId
        }
    }
}

export function setUserRole(userRole) {
    return {
        type: SET_USER_ROLE,
        payload: {
            userRole
        }
    }
}

export function setCurrentPortal(currentPortal) {
    return {
        type: SET_CURRENT_PORTAL,
        payload: {
            currentPortal
        }
    }
}

export function setPortalTimeZone(portalTimeZone) {
    return {
        type: SET_PORTAL_TIME_ZONE,
        payload: {
            portalTimeZone
        }
    }
}

export function setAvailablePortals(availablePortals) {
    return {
        type: SET_AVAILABLE_PORTALS,
        payload: {
            availablePortals
        }
    }
}

export function setAvailablePlans(availablePlans) {
    return {
        type: SET_AVAILABLE_PLANS,
        payload: {
            availablePlans
        }
    }
}

export function setIsCyberViewsEnabled(isCyberViewsEnabled) {
    return {
        type: SET_IS_CYBER_VIEWS_ENABLED,
        payload: {
            isCyberViewsEnabled
        }
    }
}

export function setIsSMELogsEnabled(isSMELogsEnabled) {
    return {
        type: SET_IS_SME_LOGS_ENABLED,
        payload: {
            isSMELogsEnabled
        }
    }
}

export function resetUser() {
    return {
        type: RESET_USER,
        payload: {}
    }
}

/* Asynchronous functions */
/**
 * Make an attempt to refresh available portals in the redux store.
 * If failed, do nothing.
 */
export function tryToRefreshAvailablePortals() {
    return function(dispatch) {
        return Api.getSessionData({attributes: [SessionDataGetSchema.availablePortals]})
        .then(resp => {
            if (resp.data[SessionDataGetSchema.availablePortals]) {
                dispatch(setAvailablePortals(resp.data[SessionDataGetSchema.availablePortals]));
            }
        })
        .catch(() => {}) // Do nothing on catch
    }
}

// export function fetchTasks() {
//     return async function(dispatch) {
//         const response = await fetch('https://nztodo.herokuapp.com/api/task/?format=json');
//         const tasks = await response.json();
//         dispatch(setTasks(tasks));
//     }
// }